<sham-status-layout imageSrc="assets/images/Done.png" [title]="'auth.resetSuccess.title' | translate"
  [description]="'auth.resetSuccess.description' | translate" [primaryBtnLabel]="'auth.resetSuccess.goToLoginPage' | translate"
  (primaryAction)="navigateToLogin()">
</sham-status-layout>